@if (showHomePageTiles) {
  <div>
    <app-home-banner></app-home-banner>

    <p class="pb-8 text-xl font-normal leading-7 text-[var(--neutral-12)] dark:text-[var(--neutral-variant-80)]">
      {{ 'dashboard.title' | translate }}
    </p>

    <div class="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      <ng-container *ngFor="let section of navigationSections$ | async">
        <ng-container *ngFor="let item of section.items">
          @if (item.subItems?.length) {
            <ng-container *ngFor="let subItem of item.subItems">
              @if (subItem.canView(subItem.identifier)) {
                <mat-card
                  appearance="outlined"
                  class="transform transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg">
                  <mat-card-content>
                    <a [routerLink]="'/' + subItem.routing" class="flex flex-col space-y-2 p-2">
                      <ng-container *ngIf="subItem.customIcon; else subDefaultIcon">
                        <div class="flex justify-start">
                          @if (isDarkMode | async) {
                            <app-svg-icon [iconSize]="32" [iconName]="subItem.customIcon + '-dark'"></app-svg-icon>
                          } @else {
                            <app-svg-icon [iconSize]="32" [iconName]="subItem.customIcon"></app-svg-icon>
                          }
                        </div>
                      </ng-container>
                      <ng-template #subDefaultIcon>
                        <mat-icon class="material-icons-outlined h-8 w-8 text-3xl">{{ subItem.icon }}</mat-icon>
                      </ng-template>

                      <div class="primary-sublabel mt-1 overflow-hidden text-ellipsis whitespace-nowrap text-2xl">
                        {{ subItem.label | translate }}
                      </div>
                      <div class="secondary-label text-sm">
                        {{ subItem.description || '' | translate }}
                      </div>
                    </a>
                  </mat-card-content>
                </mat-card>
              }
            </ng-container>
          } @else {
            @if (item.canView(item.identifier)) {
              <mat-card
                appearance="outlined"
                class="transform transition-transform duration-300 ease-in-out hover:scale-105 hover:shadow-lg">
                <mat-card-content>
                  <a [routerLink]="item.routing" class="flex flex-col space-y-2 p-2">
                    <ng-container *ngIf="item.customIcon; else itemDefaultIcon">
                      <div class="flex justify-start">
                        @if (isDarkMode | async) {
                          <app-svg-icon [iconSize]="32" [iconName]="item.customIcon + '-dark'"></app-svg-icon>
                        } @else {
                          <app-svg-icon [iconSize]="32" [iconName]="item.customIcon"></app-svg-icon>
                        }
                      </div>
                    </ng-container>
                    <ng-template #itemDefaultIcon>
                      <mat-icon class="material-icons-outlined h-8 w-8 text-3xl">{{ item.icon }}</mat-icon>
                    </ng-template>

                    <div class="primary-sublabel mt-1 overflow-hidden text-ellipsis whitespace-nowrap text-2xl">
                      {{ item.label | translate }}
                    </div>
                    <div class="secondary-label text-sm">
                      {{ item.description || '' | translate }}
                    </div>
                  </a>
                </mat-card-content>
              </mat-card>
            }
          }
        </ng-container>
      </ng-container>
    </div>
  </div>
} @else {
  <div class="mt-25 secondary-label-60 flex items-center justify-center pt-40">
    @if (isDarkMode | async) {
      <app-svg-icon [iconSize]="500" iconName="logo-dark" />
    } @else {
      <app-svg-icon [iconSize]="500" iconName="logo" />
    }
  </div>
}
